module.exports = __webpack_public_path__ + "north-korea.svg?92f5553d2e20ca6aa3e1d4f6feb024e6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/north-korea.svg
// module id = 252
// module chunks = 10